import Vue from "vue";
import Router from "vue-router";
import Order from "@/views/Order";
import Login from "@/views/Login";
import ForgotPassword from "@/views/ForgotPassword";
import OrderConfirmation from "@/views/OrderConfirmation";
import { AuthState } from "@/store/app";
Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/order",
      name: "order",
      component: Order
    },
    {
      path: "/",
      name: "login",
      component: Login
    },
    {
      path: "/forgot-password",
      name: "forgotPassword",
      component: ForgotPassword
    },
    {
      path: "/confirmation",
      name: "confirmation",
      component: OrderConfirmation
    }
  ]
});
router.beforeEach(async (to, from, next) => {
  if (!router.app.$store) return next();
  // check authentication
  await router.app.$store.dispatch("app/checkAuthenticated");
  // back to home if unauthenticated, unless going to login or forgot password
  if (
    router.app.$store.state.app.authStatus !== AuthState.AUTHENTICATED &&
    to.name !== "login" &&
    to.name !== "forgotPassword"
  ) {
    return next("/");
  }

  // if at the login screen, but are authenticated
  if (
    router.app.$store.state.app.authStatus === AuthState.AUTHENTICATED &&
    (to.name === "login" || to.name === "forgotPassword")
  ) {
    return next("order");
  }
  next();
});

export default router;
